import { createToastStore } from './toast-store.js';
import type { ToastStore } from './toast-store.js';

export const toastStore: ToastStore = createToastStore();
